export const WITHDRAWAL = 'WITHDRAWAL';
export const WITHDRAWAL_FAILED = 'WITHDRAWAL_FAILED';
export const WITHDRAWAL_SUCCEED = 'WITHDRAWAL_SUCCEED';

export const FETCH_WITHDRAWAL_HISTORY = 'FETCH_WITHDRAWAL_HISTORY';
export const FETCH_WITHDRAWAL_HISTORY_FAILED = 'FETCH_WITHDRAWAL_HISTORY_FAILED';
export const FETCH_WITHDRAWAL_HISTORY_SUCCEED = 'FETCH_WITHDRAWAL_HISTORY_SUCCEED';

export const FETCH_ADMIN_WITHDRAWAL_HISTORY = 'FETCH_ADMIN_WITHDRAWAL_HISTORY';
export const FETCH_ADMIN_WITHDRAWAL_HISTORY_FAILED = 'FETCH_ADMIN_WITHDRAWAL_HISTORY_FAILED';
export const FETCH_ADMIN_WITHDRAWAL_HISTORY_SUCCEED = 'FETCH_ADMIN_WITHDRAWAL_HISTORY_SUCCEED';

export const FETCH_USER_VOLUME_24H = 'FETCH_USER_VOLUME_24H';
export const FETCH_USER_VOLUME_24H_FAILED = 'FETCH_USER_VOLUME_24H_FAILED';
export const FETCH_USER_VOLUME_24H_SUCCEED = 'FETCH_USER_VOLUME_24H_SUCCEED';

export const WS_EVENT_USER_TRANSACTION = 'WS_EVENT_USER_TRANSACTION';

export const FETCH_USER_TRANS_HISTORY = 'FETCH_USER_TRANS_HISTORY';
export const FETCH_USER_TRANS_HISTORY_SUCCEED = 'FETCH_USER_TRANS_HISTORY_SUCCEED';
export const FETCH_USER_TRANS_HISTORY_FAILED = 'FETCH_USER_TRANS_HISTORY_FAILED';

export const FETCH_TRANS_HISTORY = 'FETCH_TRANS_HISTORY';
export const FETCH_TRANS_HISTORY_SUCCEED = 'FETCH_TRANS_HISTORY_SUCCEED';
export const FETCH_TRANS_HISTORY_FAILED = 'FETCH_TRANS_HISTORY_FAILED';

export const FETCH_TRANS_FILTER_HISTORY = 'FETCH_TRANS_FILTER_HISTORY';
export const FETCH_TRANS_FILTER_HISTORY_SUCCEED = 'FETCH_TRANS_FILTER_HISTORY_SUCCEED';
export const FETCH_TRANS_FILTER_HISTORY_FAILED = 'FETCH_TRANS_FILTER_HISTORY_FAILED';

export const FETCH_TRANS_ERROR = 'FETCH_TRANS_ERROR';
export const FETCH_TRANS_ERROR_SUCCEED = 'FETCH_TRANS_ERROR_SUCCEED';
export const FETCH_TRANS_ERROR_FAILED = 'FETCH_TRANS_ERROR_FAILED';

export const SEARCH_TRANS_ERROR = 'SEARCH_TRANS_ERROR';
export const SEARCH_TRANS_ERROR_SUCCEED = 'SEARCH_TRANS_ERROR_SUCCEED';
export const SEARCH_TRANS_ERROR_FAILED = 'SEARCH_TRANS_ERROR_FAILED';

export const FETCH_TRANS_ERROR_FILTER = 'FETCH_TRANS_FILTER_ERROR';
export const FETCH_TRANS_ERROR_FILTER_SUCCEED = 'FETCH_TRANS_ERROR_FILTER_SUCCEED';
export const FETCH_TRANS_ERROR_FILTER_FAILED = 'FETCH_TRANS_ERROR_FILTER_FAILED';

export const SEARCH_TRANSACTION_BY_ID = 'SEARCH_TRANSACTION_BY_ID';
export const SEARCH_TRANSACTION_BY_ID_SUCCEED = 'SEARCH_TRANSACTION_BY_ID_SUCCEED';
export const SEARCH_TRANSACTION_BY_ID_FAILED = 'SEARCH_TRANSACTION_BY_ID_FAILED';

export const VERIFY_TRANSACTION = 'VERIFY_TRANSACTION';
export const VERIFY_TRANSACTION_SUCCEED = 'VERIFY_TRANSACTION_SUCCEED';
export const VERIFY_TRANSACTION_FAILED = 'VERIFY_TRANSACTION_FAILED';

export const ACCEPT_TRANSACTION = 'ACCEPT_TRANSACTION';
export const ACCEPT_TRANSACTION_SUCCEED = 'ACCEPT_TRANSACTION_SUCCEED';
export const ACCEPT_TRANSACTION_FAILED = 'ACCEPT_TRANSACTION_FAILED';

export const DELETE_TRANSACTION = 'DELETE_TRANSACTION';
export const DELETE_TRANSACTION_SUCCEED = 'DELETE_TRANSACTION_SUCCEED';
export const DELETE_TRANSACTION_FAILED = 'DELETE_TRANSACTION_FAILED';

export const FETCH_VERIFY_HISTORY = 'FETCH_VERIRY_HISTORY';
export const FETCH_VERIFY_HISTORY_SUCCEED = 'FETCH_VERIRY_HISTORY_SUCCEED';
export const FETCH_VERIFY_HISTORY_FAILED = 'FETCH_VERIRY_HISTORY_FAILED';
